module.exports = __webpack_public_path__ + "static/media/navigationArrow.e361fc29.svg";